

// names of common styles 
const base_btn = 'border rounded-md border-gray-300 ';
const base_btn_hover = 'hover:bg-gray-50 cursor-pointer ';
const base_white_btn_hover = '';
const base_black_btn_hover = '';

export const input_base_style = 'rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-950 shadow-sm transition-colors placeholder:text-slate-400 hover:border-slate-300 focus:border-primaryGreen focus:outline-none focus:ring-0 focus:shadow-sm focus-visible:border-primaryGreen focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400';
export const input_label_style = 'block text-base font-medium text-gray-700 mb-1';
export const password_input_style = 'w-full pr-10 ' + input_base_style;
export const input_style = input_base_style + " w-full min-h-[48px]";


export const save_btn_style = 'cursor-pointer px-6 py-2 button-width font-semibold rounded-lg hover:scale-115 hover:opacity-50 transition';
export const save_btn_style2 = 'cursor-pointer px-6 py-2 button-width font-semibold rounded-lg hover:scale-115 hover:opacity-90 transition';
export const login_btn_style = base_btn + base_btn_hover + ' mb-2 hover:bg-gray-50'
export const form_input_style = 'w-full p-2 border border-gray-300 rounded-lg focus:ring-0 focus:outline-none'
export const input_base_style2 = 'border border-stone-200 rounded-lg px-4 py-3 text-slate-950 bg-stone-50 transition-shadow hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primaryGreen'
